import { useContext, useState } from "react";
import { Button, Tooltip, Typography } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { SMContext } from "context/smContext";
import SpaceBetweenDiv from "components/SpaceBetweenDiv";
import ModalSM from "components/ModalSM";
import Divider10 from "components/Divider10";
import SpaceBetweenButton from "components/SpaceBetweenButton";
import { updateSingleUserFsToLs } from "actions/userActions";
import AdminContainer from "components/AdminContainer";
import { mgFindManyInArray } from "actions/mongoApiActions";

export default function UserModal() {
  const [state, dispatch] = useContext(SMContext);
  const [open, setOpen] = useState(false);
  const { mapObjAll, userObj, serverID, serverObj, socket } = state;
  const { email, uid, level } = userObj;
  return (
    <>
      <Tooltip title={<Typography>User details</Typography>} placement="bottom">
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          onClick={() => setOpen(true)}
        >
          <AccountCircle />
        </Button>
      </Tooltip>
      <ModalSM
        open={open}
        onClose={() => setOpen(false)}
        modalTitle="User"
        modalIcon={<AccountCircle />}
        minWidth="70vw"
        minHeight="50vh"
      >
        {/* <Button
          onClick={async () => {
            const arr = await mgFindManyInArray("gateway", "gatewayID", [
              "GW1ab840",
              "GW102012",
            ]);
          }}
        >
          test
        </Button> */}
        <SpaceBetweenDiv title="User" data={email} />
        <SpaceBetweenDiv title="uid" data={uid} />
        <SpaceBetweenDiv title="Level" data={level} />
        <Divider10 />
        <AdminContainer>
          <SpaceBetweenButton
            title="Update user info from cloud"
            btnContent="update"
            onBtnClick={async () => {
              await updateSingleUserFsToLs(socket, uid);
            }}
          />
          <Divider10 />
        </AdminContainer>
        {/* <Button
          onClick={async () => {
            const res = await mgDeleteMany("map", { mapID: "map_u389ifcx" });
            console.log(res);
          }}
        >
          delete map_u389ifcx
        </Button> */}
        <SpaceBetweenDiv
          title="Maps"
          data={Object.keys(mapObjAll || {}).map((mid) => {
            return (
              <Typography display="block" variant="caption" key={mid}>
                {mapObjAll[mid].mapName} [{mid}]
              </Typography>
            );
          })}
        />
      </ModalSM>
    </>
  );
}
